import { Col, Row } from 'reactstrap';
import { useState } from 'react';
import BusinessFilter from '../../../../common/filter/businessFilter';
import VersementsHistory from './mobile/versementsHistory';
import VersementsBanksHistory from './bank/versementsBankHistory';
import { FaMobileAlt, FaCreditCard } from 'react-icons/fa';
import '../../utils/historyTabs.css';

const History = () => {
  const [selectedBusiness, setSelectedBusiness] = useState(null);
  const [activeTab, setActiveTab] = useState('mobile');

  return (
    <div>
        <div className="title-page-country mt-2 mb-5">
            Historique de mes versements {activeTab} 
        </div>
        <div className="top-bar mb-4 mt-4">
            <div className="business-filter">
            <BusinessFilter onFilter={({ business }) => setSelectedBusiness(business)} />
            </div>
            <div className="tabs">
            <button
                className={`tab-button ${activeTab === 'mobile' ? 'active' : ''}`}
                onClick={() => setActiveTab('mobile')}
            >
                <FaMobileAlt className="tab-icon" />
                Mobile Money
            </button>
            <button
                className={`tab-button ${activeTab === 'bancaire' ? 'active' : ''}`}
                onClick={() => setActiveTab('bancaire')}
            >
                <FaCreditCard className="tab-icon" />
                Compte Bancaire
            </button>
            </div>
        </div>

        <Row>
            <Col lg={12}>
            <div className={`tab-content ${activeTab === 'mobile' ? 'show' : 'hide'}`}>
                <VersementsHistory busId={selectedBusiness?.id} />
            </div>
            <div className={`tab-content ${activeTab === 'bancaire' ? 'show' : 'hide'}`}>
                <VersementsBanksHistory busId={selectedBusiness?.id} />
            </div>
            </Col>
        </Row>
    </div>
  );
};

export default History;